import { useMessages } from "../../context/MessageContext";
import "./MessageList.css";

function MessageList() {
  const { messages } = useMessages();

  return (
    <div className="message-container">
      {messages.map((msg) => (
        <div key={msg.id} className={`message ${msg.type}`}>
          {msg.text}
        </div>
      ))}
    </div>
  );
}

export default MessageList;